import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="items--input"
export default class extends Controller {
	onFocus() {
		if (parseFloat(this.element.value) == 0.0) {
			this.element.value = "";
		}
	}

	onFocusOut() {
		if (this.element.value.trim() == "") {
			this.element.value = "0.0";
		}
	}

	onInput() {
		console.log(parseFloat(this.element.value));
		if (isNaN(Number(this.element.value))) {
			this.element.value = "";
		}
	}
}
